// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var clamp = "Row-module--clamp--9deef";
export var complete = "Row-module--complete--cfd15";
export var emphasis = "Row-module--emphasis--2a5f0";
export var green = "#57d33b";
export var greenLink = "Row-module--green-link--b8fa3";
export var grey = "var(--tone-mid)";
export var header = "Row-module--header--8f925";
export var icon = "Row-module--icon--ace88";
export var largeIcon = "Row-module--largeIcon--d6736";
export var notchGap = "32px";
export var orange = "#f8662b";
export var raceNumber = "Row-module--raceNumber--8c92b";
export var red = "#ff2741";
export var row = "Row-module--row--9364f";
export var subHeader = "Row-module--subHeader--931dd";
export var title = "Row-module--title--28abf";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";